import {Box, Text, Title} from '@mantine/core';
import type {FC} from 'react';
import {MdSchool} from 'react-icons/md';
import {
  GTAG_EVENT_NAMES,
  GTAG_LOCATION,
} from '../../../../config/constants/gtag';
import {AcEmailVerificationFormContainer} from '../../../../shared/components/AcEmailVerificationForm';
import {PromptModal} from '../../../../shared/components/PromptModal';
import {useImpressionGtagEvent} from '../../../../shared/services/useImpressionGtagEvent';

export const UNIVERSITY_EMAIL_VERIFY_PROMPT_COMPONENT_ID =
  'university-email-verify-prompt';

type Props = {
  opened: boolean;
  onClose: () => void;
};

export const UniversityEmailVerifyPromptModal: FC<Props> = ({
  opened,
  onClose,
}) => {
  useImpressionGtagEvent({
    eventName: GTAG_EVENT_NAMES.IMP_UNIVERSITY_EMAIL_VERIFY_PROMPT,
    active: opened,
  });

  return (
    <PromptModal
      opened={opened}
      onClose={onClose}
      componentId={UNIVERSITY_EMAIL_VERIFY_PROMPT_COMPONENT_ID}
    >
      <div className="flex flex-col items-center text-center">
        <Box className="flex h-[56px] w-[56px] items-center justify-center rounded-full bg-background-3">
          <MdSchool size={28} className="text-primary-1" />
        </Box>
        <Title
          order={2}
          className="mt-16 text-lg font-bold leading text-black-1"
        >
          大学メールアドレスの認証をお願いします
        </Title>
        <Text className="mt-8 text-sm leading text-black-2">
          在学中の大学メールアドレスを認証すると、募集へのエントリーや選考体験記・エントリーシートの閲覧などの限定機能がご利用いただけます。
        </Text>
      </div>

      <AcEmailVerificationFormContainer
        gtagLocation={GTAG_LOCATION.UNIVERSITY_EMAIL_VERIFY_PROMPT}
      />
    </PromptModal>
  );
};
